import { tv } from 'tailwind-variants'

import { typography } from '@gto/ui/typography'

export const fieldVariants = tv({
  slots: {
    root: 'group/field flex flex-col gap-0.5',
    label: [
      typography['input/label'],
      'flex cursor-pointer items-center gap-1 min-h-4 px-2 transition-colors',

      'group-has-[input:hover:not(:focus):not(:disabled):not(:invalid)]/field:text-text-primary',
      'group-has-[:focus-visible]/field:text-primary-main',
      'group-has-[[data-popup-open]]/field:text-primary-main',
      'group-has-[:invalid]/field:text-error-main',
      'group-has-[[aria-invalid=true]]/field:text-error-main',
      'group-has-[:disabled]/field:text-text-disabled',
    ],
    error: 'px-2 text-error-main text-[10px] leading-[166%] tracking-[0.4px]',
  },
})
